(function () {
    var SUPABASE_URL = 'https://xjqxifpxjvqrojhkmecg.supabase.co';
    var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhqcXhpZnB4anZxcm9qaGttZWNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgyNTEzMDIsImV4cCI6MjA5MzgyNzMwMn0.nzfMJL-zpvqiVIEVbkALLjf2tRPFjHiHDYdXF-5Uo3Y';
    var SESSION_KEY = 'althurayat_platform_admin_session';
    var PREVIEW_THEME_ID = new URLSearchParams(window.location.search).get('preview_theme_id') || '';
    var DASHBOARD_URL = adminReturnURL();
    function adminReturnURL() {
      var localeRoot = document.querySelector('[data-admin-auth-v20]').dataset.root.replace(/\/$/, '') + '/';
      var fallback = withPreviewTheme(localeRoot + 'pages/platform-admin');
      var requested = new URLSearchParams(window.location.search).get('return_to');
      if (!requested) return fallback;
      try {
        var target = new URL(requested, window.location.origin);
        var allowed = /^\/(?:(?:en|ar)-ae\/)?pages\/(?:platform-admin|admin-[a-z0-9-]+|partners-approval|transaction-approvals|project-disputes)$/;
        if (target.origin !== window.location.origin || !allowed.test(target.pathname) || target.pathname.endsWith('admin-login')) return fallback;
        return withPreviewTheme(target.pathname + target.search);
      } catch (_) { return fallback; }
    }
    var SECURITY_FUNCTION_URL = SUPABASE_URL + '/functions/v1/admin-security-check';
    var supabaseClient = null;

    if (window.supabase && window.supabase.createClient) {
      supabaseClient = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        auth: {
          persistSession: false,
          autoRefreshToken: false,
          detectSessionInUrl: false
        }
      });
    }

    var form = document.getElementById('atPlatformAdminLoginForm');
    var resetForm = document.getElementById('atPlatformAdminResetForm');
    var newPasswordForm = document.getElementById('atPlatformAdminNewPasswordForm');
    var message = document.getElementById('atPlatformAdminLoginMessage');
    var submit = document.getElementById('atPlatformAdminLoginSubmit');
    var resetMessage = document.getElementById('atPlatformAdminResetMessage');
    var resetSubmit = document.getElementById('atPlatformAdminResetSubmit');
    var newPasswordMessage = document.getElementById('atPlatformAdminNewPasswordMessage');
    var newPasswordSubmit = document.getElementById('atPlatformAdminNewPasswordSubmit');
    var recoveryToken = getRecoveryToken();
    var captchaTokenValue = '';
    var captchaWidgetId = null;
    var verificationTimer = null;
    var verificationRetry = document.getElementById('atLoginVerificationRetry');
    var verificationLabels = {"ar": {"retry": "إعادة التحقق", "failed": "لم يكتمل التحقق الأمني", "stalled": "تعذر إكمال التحقق الأمني. اضغط إعادة التحقق؛ وإذا استمر الخطأ احتفظ برمزه لمراجعة إعدادات الحماية."}, "en": {"retry": "Retry verification", "failed": "Security verification did not complete", "stalled": "Security verification could not finish. Retry verification; if the error continues, retain its code to review the security settings."}};
    var verificationCopy = verificationLabels[document.documentElement.lang.indexOf('ar') === 0 ? 'ar' : 'en'];
    function syncVerificationCopy() {
      var previous = verificationCopy;
      verificationCopy = verificationLabels[document.documentElement.lang.indexOf('ar') === 0 ? 'ar' : 'en'];
      if (verificationRetry) verificationRetry.textContent = verificationCopy.retry;
      var label = document.getElementById('atLoginVerificationText');
      if (label && label.textContent.indexOf(previous.failed) === 0) label.textContent = verificationCopy.failed + label.textContent.slice(previous.failed.length);
      if (message && message.textContent.indexOf(previous.stalled) === 0) message.textContent = verificationCopy.stalled + message.textContent.slice(previous.stalled.length);
    }
    syncVerificationCopy();
    new MutationObserver(syncVerificationCopy).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
    function verificationFailed(code) {
      window.clearTimeout(verificationTimer);
      captchaTokenValue = '';
      submit.disabled = true;
      var safeCode = /^[0-9]{6}$/.test(String(code)) ? ' (' + code + ')' : '';
      updateVerification('error', verificationCopy.failed + safeCode);
      showMessage(verificationCopy.stalled + safeCode, true);
      if (verificationRetry) verificationRetry.hidden = false;
    }
    function watchVerification() {
      window.clearTimeout(verificationTimer);
      verificationTimer = window.setTimeout(function () {
        if (!captchaTokenValue) verificationFailed('');
      }, 30000);
    }
    if (verificationRetry) verificationRetry.addEventListener('click', function () {
      verificationRetry.hidden = true;
      showMessage('', false);
      if (captchaWidgetId === null) initTurnstileWhenReady();
      else resetCaptcha();
    });
    function updateVerification(state, text) {
      var badge = document.getElementById('atLoginVerification');
      var label = document.getElementById('atLoginVerificationText');
      if (badge) { badge.setAttribute('data-state', state); badge.hidden = state !== 'error' && state !== 'interactive'; }
      if (label) { label.setAttribute('data-at-i18n-dynamic', ''); label.textContent = text; }
    }

    if (!form) return;
    submit.setAttribute('data-at-i18n-dynamic', '');
    if (!isCaptchaEnabled()) { submit.disabled = true; updateVerification('error', window.ATLocale.t("ui.a1d895dcf36e")); }

    if (isCaptchaEnabled()) {
      submit.disabled = true;
      submit.textContent = window.ATLocale.t("ui.71d4437f0318");
      initTurnstileWhenReady();
    }

    if (recoveryToken) {
      showView('new_password');
    } else {
      var existingSession = getSession();
      var sessionParam = new URLSearchParams(window.location.search).get('session') || '';

      if (existingSession && isSessionExpired(existingSession)) {
        clearAdminSession();
        existingSession = null;
      }

      if (existingSession && existingSession.access_token && existingSession.admin) {
        form.innerHTML =
          '<div class="at-admin-login__message">' +
            window.ATLocale.t("ui.2bb53ebae9cd") +
            '<div style="display:grid;gap:8px;margin-top:12px;">' +
              '<a class="at-admin-login__link" href="' + DASHBOARD_URL + window.ATLocale.t("ui.3b788b4e0452") +
              window.ATLocale.t("ui.f5e61185041f") +
            '</div>' +
          '</div>';

        var logoutButton = document.getElementById('atPlatformAdminLogout');
        if (logoutButton) {
          logoutButton.addEventListener('click', function () {
            logoutAdminSession(existingSession);
          });
        }
        return;
      }

      if (sessionParam === 'expired') {
        showMessage(window.ATLocale.t("ui.eb143ee778eb"), true);
      } else if (sessionParam === 'logout') {
        showMessage(window.ATLocale.t("ui.a87b11cbe404"), false, true);
      }
    }

    var showResetButton = document.getElementById('atShowPasswordReset');
    var backToLoginFromReset = document.getElementById('atBackToLoginFromReset');
    var backToLoginFromNewPassword = document.getElementById('atBackToLoginFromNewPassword');

    if (showResetButton) showResetButton.addEventListener('click', function () { showView('reset'); });
    if (backToLoginFromReset) backToLoginFromReset.addEventListener('click', function () { showView('login'); });
    if (backToLoginFromNewPassword) backToLoginFromNewPassword.addEventListener('click', function () { showView('login'); });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var formData = new FormData(form);
      var email = String(formData.get('email') || '').trim();
      var password = String(formData.get('password') || '');
      var captchaToken = getCaptchaToken();

      if (!email || !password) {
        showMessage(window.ATLocale.t("ui.07721dca9c9f"), true);
        return;
      }

      if (isCaptchaEnabled() && !captchaToken) {
        showMessage(window.ATLocale.t("ui.0395bfaecefd"), true);
        return;
      }

      submit.disabled = true;
      submit.textContent = window.ATLocale.t("ui.3e7c53fa17a7");
      showMessage(window.ATLocale.t("ui.dd94eba243ec"), false);

      try {
        var secureLogin = await securityCheck('login', {
          email: email,
          password: password,
          captcha_token: captchaToken
        });

        if (!secureLogin || !secureLogin.session || !secureLogin.session.access_token || !secureLogin.admin) {
          throw new Error(window.ATLocale.t("ui.9fb8539f5282"));
        }

        var sessionExpiresAt = null;
        if (secureLogin.session.expires_at) {
          sessionExpiresAt = Number(secureLogin.session.expires_at) * 1000;
        } else if (secureLogin.session.expires_in) {
          sessionExpiresAt = Date.now() + Number(secureLogin.session.expires_in) * 1000;
        }

        localStorage.setItem(SESSION_KEY, JSON.stringify({
          access_token: secureLogin.session.access_token,
          refresh_token: secureLogin.session.refresh_token || '',
          expires_at: sessionExpiresAt,
          admin: secureLogin.admin
        }));

        window.location.href = DASHBOARD_URL;
      } catch (error) {
        resetCaptcha();
        showMessage(error.message || window.ATLocale.t("ui.78b023ee9bae"), true);
      } finally {
        if (isCaptchaEnabled()) {
          submit.disabled = !captchaTokenValue;
          submit.textContent = captchaTokenValue ? window.ATLocale.t("ui.beb869eecc12") : window.ATLocale.t("ui.456e87d3ecf2");
        } else {
          submit.disabled = false;
          submit.textContent = window.ATLocale.t("ui.beb869eecc12");
        }
      }
    });

    if (resetForm) {
      resetForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        var formData = new FormData(resetForm);
        var email = String(formData.get('email') || '').trim();
        if (!email) {
          showFormMessage(resetMessage, window.ATLocale.t("ui.d52d1ee0049c"), true);
          return;
        }
        resetSubmit.disabled = true;
        resetSubmit.textContent = window.ATLocale.t("ui.5c94b7a19206");
        showFormMessage(resetMessage, window.ATLocale.t("ui.72b2e2f78a85"), false);
        try {
          await requestPasswordReset(email);
          showFormMessage(resetMessage, window.ATLocale.t("ui.0d3c6b3a374e"), false, true);
        } catch (error) {
          showFormMessage(resetMessage, error.message || window.ATLocale.t("ui.dca62f048914"), true);
        } finally {
          resetSubmit.disabled = false;
          resetSubmit.textContent = window.ATLocale.t("ui.54e0e9f69b92");
        }
      });
    }

    if (newPasswordForm) {
      newPasswordForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        var formData = new FormData(newPasswordForm);
        var password = String(formData.get('password') || '');
        var confirm = String(formData.get('password_confirm') || '');
        if (!recoveryToken) {
          showFormMessage(newPasswordMessage, window.ATLocale.t("ui.494cc8035ba4"), true);
          return;
        }
        if (password.length < 8) {
          showFormMessage(newPasswordMessage, window.ATLocale.t("ui.733deb7b29c9"), true);
          return;
        }
        if (password !== confirm) {
          showFormMessage(newPasswordMessage, window.ATLocale.t("ui.55a9693ae42b"), true);
          return;
        }
        newPasswordSubmit.disabled = true;
        newPasswordSubmit.textContent = window.ATLocale.t("ui.8688b0ff5f34");
        showFormMessage(newPasswordMessage, window.ATLocale.t("ui.8c39eef5c738"), false);
        try {
          await updatePassword(password, recoveryToken);
          localStorage.removeItem(SESSION_KEY);
          history.replaceState(null, '', window.location.pathname);
          recoveryToken = '';
          showView('login');
          showMessage(window.ATLocale.t("ui.160a3fe80459"), false, true);
        } catch (error) {
          showFormMessage(newPasswordMessage, error.message || window.ATLocale.t("ui.568c115c6308"), true);
        } finally {
          newPasswordSubmit.disabled = false;
          newPasswordSubmit.textContent = window.ATLocale.t("ui.2a9148a76cbc");
        }
      });
    }


    function isCaptchaEnabled() {
      return !!document.getElementById('atPlatformAdminTurnstile');
    }

    function initTurnstileWhenReady() {
      if (!isCaptchaEnabled()) return;

      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;

        if (window.turnstile && typeof window.turnstile.render === 'function') {
          window.clearInterval(timer);
          renderTurnstile();
          return;
        }

        if (attempts >= 40) {
          window.clearInterval(timer);
          verificationFailed('');
          submit.disabled = true;
          submit.textContent = window.ATLocale.t("ui.18e8915edf7e");
          updateVerification('error', window.ATLocale.t("ui.3a4ecca11e0e"));
          showMessage(window.ATLocale.t("ui.4393ed9a066f"), true);
        }
      }, 250);
    }

    function renderTurnstile() {
      var target = document.getElementById('atPlatformAdminTurnstile');
      if (!target || !window.turnstile) return;

      var siteKey = target.getAttribute('data-sitekey') || '';
      if (!siteKey) {
        submit.disabled = true;
        showMessage(window.ATLocale.t("ui.25b19608204b"), true);
        return;
      }

      try {
        captchaWidgetId = window.turnstile.render(target, {
          sitekey: siteKey,
          theme: 'light',
          size: 'flexible',
          appearance: 'always',
          execution: 'render',
          'before-interactive-callback': function () { window.clearTimeout(verificationTimer); submit.textContent = window.ATLocale.t("ui.456e87d3ecf2"); updateVerification('interactive', window.ATLocale.t("ui.e06f01bf4fa4")); },
          'after-interactive-callback': function () { if (!captchaTokenValue) { updateVerification('pending', verificationCopy.retry); watchVerification(); } },
          retry: 'never',
          'refresh-expired': 'auto',
          'refresh-timeout': 'auto',
          callback: function (token) {
            window.clearTimeout(verificationTimer);
            if (verificationRetry) verificationRetry.hidden = true;
            captchaTokenValue = String(token || '');
            submit.disabled = !captchaTokenValue;
            submit.textContent = captchaTokenValue ? window.ATLocale.t("ui.beb869eecc12") : window.ATLocale.t("ui.456e87d3ecf2");
            if (captchaTokenValue) {
              updateVerification('ready', window.ATLocale.t("ui.47725d473f7c"));
              showMessage(window.ATLocale.t("ui.e6d6e58f4624"), false);
            }
          },
          'expired-callback': function () {
            captchaTokenValue = '';
            submit.disabled = true;
            submit.textContent = window.ATLocale.t("ui.456e87d3ecf2");
            updateVerification('pending', window.ATLocale.t("ui.38eeaba4f7dc"));
            watchVerification();
          },
          'timeout-callback': function () { verificationFailed(''); },
          'error-callback': function (errorCode) {
            verificationFailed(errorCode);
            return true;
          }
        });
        watchVerification();
      } catch (error) {
        verificationFailed('');
        submit.disabled = true;
        submit.textContent = window.ATLocale.t("ui.18e8915edf7e");
        showMessage(window.ATLocale.t("ui.99f96d22e3e8"), true);
      }
    }

    function getCaptchaToken() {
      return captchaTokenValue;
    }

    function resetCaptcha() {
      updateVerification('pending', window.ATLocale.t("ui.38eeaba4f7dc"));
      captchaTokenValue = '';
      submit.disabled = true;
      submit.textContent = window.ATLocale.t("ui.456e87d3ecf2");

      if (window.turnstile && captchaWidgetId !== null) {
        try { window.turnstile.reset(captchaWidgetId); watchVerification(); } catch (error) { verificationFailed(''); }
      }
    }

    function withPreviewTheme(path) {
      if (!PREVIEW_THEME_ID) return path;
      var separator = path.indexOf('?') === -1 ? '?' : '&';
      return path + separator + 'preview_theme_id=' + encodeURIComponent(PREVIEW_THEME_ID);
    }

    async function securityCheck(action, payload) {
      var response = await fetch(SECURITY_FUNCTION_URL, {
        method: 'POST',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(Object.assign({ action: action }, payload || {})),
        signal: AbortSignal.timeout(25000)
      });

      var data = await response.json().catch(function () { return null; });
      if (!response.ok || (data && data.allowed === false)) {
        throw new Error((data && data.message) || window.ATLocale.t("ui.b738b037cb16"));
      }
      return data;
    }

    async function requestPasswordReset(email) {
      var redirectTo = window.location.origin + window.location.pathname + '?reset=1';
      var response = await fetch(SUPABASE_URL + '/functions/v1/at-mail-public', {
        method: 'POST',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          action: 'reset', language: (String(window.ATLocale && window.ATLocale.language || document.documentElement.lang || 'ar').toLowerCase().startsWith('en') ? 'en' : 'ar')
        })
      });
      var data = await response.json().catch(function () { return null; });
      if (!response.ok) throw new Error((data && (data.msg || data.message || data.error_description || data.error)) || window.ATLocale.t("ui.7e3506bddf61"));
      return data;
    }

    async function updatePassword(password, accessToken) {
      var response = await fetch(SUPABASE_URL + '/auth/v1/user', {
        method: 'PUT',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: password })
      });
      var data = await response.json().catch(function () { return null; });
      if (!response.ok) throw new Error((data && (data.msg || data.message || data.error_description || data.error)) || window.ATLocale.t("ui.61927c9148b3"));
      return data;
    }

    function getRecoveryToken() {
      var hash = window.location.hash ? window.location.hash.slice(1) : '';
      var params = new URLSearchParams(hash);
      var type = params.get('type') || new URLSearchParams(window.location.search).get('type');
      var token = params.get('access_token') || '';
      if (token && (!type || type === 'recovery')) return token;
      return '';
    }

    function showView(view) {
      if (form) form.hidden = view !== 'login';
      if (resetForm) resetForm.hidden = view !== 'reset';
      if (newPasswordForm) newPasswordForm.hidden = view !== 'new_password';
    }

    async function signIn(email, password) {
      if (supabaseClient && supabaseClient.auth && supabaseClient.auth.signInWithPassword) {
        var result = await supabaseClient.auth.signInWithPassword({
          email: email,
          password: password
        });

        if (result.error) {
          throw new Error(result.error.message || window.ATLocale.t("ui.037def4dc69b"));
        }

        if (!result.data || !result.data.session || !result.data.session.access_token) {
          throw new Error(window.ATLocale.t("ui.8e2d952c2b85"));
        }

        return {
          access_token: result.data.session.access_token,
          refresh_token: result.data.session.refresh_token || '',
          expires_in: result.data.session.expires_in || null,
          user: result.data.user || null
        };
      }

      var response = await fetch(SUPABASE_URL + '/auth/v1/token?grant_type=password', {
        method: 'POST',
        mode: 'cors',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + SUPABASE_ANON_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      });

      var data = await response.json().catch(function () { return null; });
      if (!response.ok) throw new Error((data && (data.msg || data.message || data.error_description || data.error)) || window.ATLocale.t("ui.037def4dc69b"));
      return data;
    }

    async function loadAdmin(accessToken) {
      var response = await fetch(SUPABASE_URL + '/rest/v1/rpc/get_current_platform_admin', {
        method: 'POST',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });

      var data = await response.json().catch(function () { return null; });
      if (!response.ok) throw new Error((data && (data.message || data.error_description || data.error)) || window.ATLocale.t("ui.87b50f6d3fe1"));
      return Array.isArray(data) ? data[0] : data;
    }

    function showMessage(text, isError, isSuccess) {
      showFormMessage(message, text, isError, isSuccess);
    }

    function showFormMessage(element, text, isError, isSuccess) {
      if (!element) return;
      element.setAttribute('data-at-i18n-dynamic', '');
      element.textContent = text;
      element.classList.toggle('is-error', !!isError);
      element.classList.toggle('is-success', !!isSuccess && !isError);
    }

    function isSessionExpired(session) {
      var expiresAt = Number(session && session.expires_at ? session.expires_at : 0);
      return !!expiresAt && Date.now() >= expiresAt;
    }

    function clearAdminSession() {
      try {
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem('althurayat_platform_admin_last_activity');
      } catch (error) {}
      try { sessionStorage.removeItem(SESSION_KEY); } catch (error) {}
    }

    async function logoutAdminSession(session) {
      var accessToken = session && session.access_token ? session.access_token : '';
      clearAdminSession();

      if (accessToken) {
        try {
          await fetch(SUPABASE_URL + '/auth/v1/logout', {
            method: 'POST',
            headers: {
              apikey: SUPABASE_ANON_KEY,
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json'
            },
            body: '{}'
          });
        } catch (error) {}
      }

      var logoutUrl = window.location.pathname + '?session=logout';
      if (PREVIEW_THEME_ID) {
        logoutUrl += '&preview_theme_id=' + encodeURIComponent(PREVIEW_THEME_ID);
      }
      window.location.replace(logoutUrl);
    }

    function getSession() {
      try {
        return JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
      } catch (error) {
        return null;
      }
    }
  })();
